// extracted by mini-css-extract-plugin
export default {"main-button":"MainButton_main-button__ZAq3V"};